<div class="grid grid-cols-5 gap-1 py-1">
  <div
    *ngFor="let seatNo of seatCount"
    class="flex items-center justify-center px-1 py-1 text-[10px] uppercase"
    [ngClass]="{
      'btn-secondary-v3': _playerService.currentSeatNoFromDealer !== seatNo,
      'btn-default-v3': _playerService.currentSeatNoFromDealer === seatNo
    }"
  >
    Seat {{ seatNo }}
    <span *ngIf="seatNo === currentSeatNo" class="ml-1"> You</span>
  </div>
</div>
<div class="cards" [class.!border-white]="isPlayerTurn" *ngIf="deckCards.length > 0; else noCards">
  <div [class.card-down-animation]="deckCards[0]" id="firstCard">
    <div [class.open-card]="deckCards[0]">
      <svg-icon svgClass="w-full h-full" [src]="buildUrl(deckCards[0])"></svg-icon>
    </div>
  </div>
  <div [class.card-down-animation]="deckCards[1]" id="secondCard" class="card-down-animation">
    <div [class.open-card]="deckCards[1]">
      <svg-icon svgClass="w-full h-full" [src]="buildUrl(deckCards[1])"></svg-icon>
    </div>
  </div>
  <div
    [class.card-down-animation]="deckCards[2]"
    id="maverickCard"
    class="card-down-animation"
    *ngIf="deckCards[2]"
  >
    <div [class.maverick-card]="deckCards[2]">
      <svg-icon svgClass="w-full h-full" [src]="buildUrl(deckCards[2])"></svg-icon>
    </div>
  </div>
</div>
<ng-template #noCards>
  <div class="cards" [class.!border-white]="isPlayerTurn"></div>
</ng-template>
